export default __webpack_public_path__ + "static/media/Logo_yellow.1b1b3e3f.webp";